import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminPanel from './pages/AdminPanel';
import UserPanel from './pages/UserPanel';
import SharePage from './pages/SharePage';
import SendFiles from './pages/SendFiles';
import PrivacyPolicy from './pages/PrivacyPolicy';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminPanel />} />
        <Route path="/panel/*" element={<UserPanel />} />
        <Route path="/s/:id" element={<SharePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/" element={<SendFiles />} />
        <Route path="*" element={<SendFiles />} />
      </Routes>
    </BrowserRouter>
  );
}
// v4